import { FC, useMemo } from 'react'
import * as styles from 'styles/atoms/buttons/PageFooterButton.css'
import { AnchorPlacement } from 'interfaces/navigation'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import { StrippedFragment } from 'components/features/pfm/StrippedFragment/StrippedFragment'

type PageFooterButtonProps = {
  text: string
  to?: AnchorPlacement
  onClick?: () => void
}

export const PageFooterButton: FC<PageFooterButtonProps> = (props) => {
  const { to, text, onClick } = props

  const Render = useMemo<FC>(() => {
    if (!to) {
      return StrippedFragment
    }

    return ({ children }) => (
      <NavigationLink to={ to }>{ children }</NavigationLink>
    )
  }, [to])

  return (
    <div className={ styles.pageFooterButton }>
      <div className={ styles.pageFooterButtonInner }>
        <Render>
          <Button
            style='hollow'
            fullWidth
            onClick={ onClick }
          >
            { text }
          </Button>
        </Render>
      </div>
    </div>
  )
}

export default PageFooterButton
